import { MarktingCard } from "../../AvatarDigitalMarketer/AiMarketingTeam";
import Box from "../../components/Box";
import Text from "../../components/Text";
import Button from "../../components/Button";

const points = [
    { icon: "", text: "Auto-checks homework status from students and parents" },
    { icon: "", text: "Sends smart reminders until work is complete" },
    { icon: "", text: "Updates teacher dashboard in real time" },
    { icon: "", text: "Works via App and WhatsApp — no new apps or training needed" },
];

const aiExpertData = [{
    title: "What It Does",
    description: <div className="space-y-3">
        <ul className="list-inside list-disc">
            {points.map((section, index) => (
                <li key={"fqweqwewe" + index}><Text label={section.text} cName="text-gray-700 text-xs leading-relaxed" /></li>
            ))}
        </ul>
    </div>,

}, {
    title: "Real Impact",
    description: "Saves 4,400+ teacher hours every year (for an average strength of 20 teachers). Up to ₹8+ lakh saved in teacher time. Ensures 100% homework completion and accountability.",
    footer: <div className="flex md:flex-col items-center gap-4">
        <Button label='Book Live Demo' type='gradient' />
        <Button label='Claim ₹5 Lakh Free Access' type='outlined' />
    </div>

}];


export default function AiExpert() {

    return (
        <Box
            badge={"INTRODUCING"}
            title={"AI Expert — Homework Assist"}
            description={"Never Chase Homework Again. 10 mins per class per day is gone in homework tracking, sounds really small right? but if you add it up in the entire academic year it adds up to 4400 teaching hours gone or an average of 3.5 years of teaching time per teacher."}
            leftBlock={aiExpertData.map((member, index) => <MarktingCard key={"AiExpert" + index} member={member} />)}
        />
    );
}